export default __webpack_public_path__ + "static/media/al-photo.f3e108a6.jpeg";